import uuid from 'uuid'

export const createId = () => {
  return  uuid.v4().slice(0, 8)
}
